import { useEffect } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import Button from '@/components/core/Button';
import { useAvailableAppUpdate } from '@/hooks/useAvailableAppUpdate';
import { toast } from '@/hooks/useToast';

const reloadPage = () => {
  window.location.reload();
};

export const AppUpdateNotice = () => {
  const { formatMessage } = useIntl();
  const availableVersion = useAvailableAppUpdate();

  useEffect(() => {
    if (!availableVersion) {
      return;
    }

    toast.warning(
      {
        title: formatMessage({
          defaultMessage: 'En ny version av portalen finns',
        }),
        description: formatMessage({
          defaultMessage:
            'Ladda om sidan för att använda den senaste versionen. Spara det du arbetar med först.',
        }),
        action: (
          <Button variant="filled" onClick={reloadPage}>
            <FormattedMessage defaultMessage="Ladda om sidan" />
          </Button>
        ),
      },
      {
        toastId: `app-update-${availableVersion}`,
        autoClose: false,
        closeOnClick: false,
      },
    );
  }, [availableVersion, formatMessage]);

  return null;
};
